export { default } from './TimezoneChoicePopUp';



// WEBPACK FOOTER //
// ./src/components/UserAccount/Confirms/ConfirmNoticeBlocks/TimezoneChoicePopUp/index.js